import(/* webpackMode: "eager" */ "/builds/publishing-cms-concurrent-0/web/app/global-error.tsx");
